export default class CheckboxOptionElement extends HTMLElement {
  constructor() {
    super();

    this.onClick = this.onClick.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
  }

  connectedCallback() {
    this.setAttribute('role', 'checkbox');
    this.setAttribute('tabindex', '0');

    this.addEventListener('click', this.onClick);
    this.addEventListener('focus', this.onFocus);
    this.addEventListener('blur', this.onBlur);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('focus', this.onFocus);
    this.removeEventListener('blur', this.onBlur);
  }

  static get observedAttributes(): string[] {
    return ['checked'];
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
    if (oldValue === newValue) return;

    switch (name) {
      case 'checked':
        if (newValue !== null) {
          this.setAttribute('aria-checked', 'true');
          this.dispatch('checked');
        } else {
          this.removeAttribute('aria-checked');
          this.dispatch('unchecked');
        }
        break;
      default:
        break;
    }
  }

  onClick(event: Event) {
    event.preventDefault();
    this.checked = !this.hasAttribute('checked');
  }

  onFocus() {
    this.addEventListener('keydown', this.onKeydown);
  }

  onBlur() {
    this.removeEventListener('keydown', this.onKeydown);
  }

  onKeydown(event: KeyboardEvent) {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      this.click();
    }
  }

  get checked(): boolean {
    return this.hasAttribute('checked');
  }

  set checked(value: boolean) {
    if (value) {
      this.setAttribute('checked', 'true');
    } else {
      this.removeAttribute('checked');
    }
  }

  get value() {
    return this.getAttribute('value');
  }

  dispatch(eventName: string) {
    this.dispatchEvent(new CustomEvent(`checkbox-option:${eventName}`, { bubbles: true }));
  }
}
